import React from 'react';
import { Link, useLocation } from 'react-router';
import { Badge, Gutter, HeaderBarLink, Layout, LayoutItem } from '@axiom/ui';

export type EngagementsHistoryViewNavigationItemProps = {
  children: React.ReactNode;
  name?: string;
  target?: string;
  url: string;
  badgeCount: number;
};

export const EngagementsHistoryViewNavigationItem = ({
  children,
  name,
  target,
  url,
  badgeCount,
}: EngagementsHistoryViewNavigationItemProps) => {
  const location = useLocation();
  return (
    <Layout name={name}>
      <LayoutItem>
        <HeaderBarLink
          selected={location.pathname.endsWith(url.replace('./', ''))}
          name="HISTORY_NAVIGATION_HEADER"
        >
          <Link
            to={url}
            target={target}
            data-test="HISTORY_NAVIGATION_HEADER_LINK"
          >
            {children}
          </Link>
        </HeaderBarLink>
      </LayoutItem>
      {badgeCount > 0 && (
        <LayoutItem>
          <Gutter left="8px">
            <Badge background="orange" name="NOTIFICATION_BADGE">
              {badgeCount}
            </Badge>
          </Gutter>
        </LayoutItem>
      )}
    </Layout>
  );
};
